import React from "react";
import { AccordionProps } from "./Accordion.type";
import { Default } from "./variations/Default";

export const Accordion: React.FC<AccordionProps> = (props) => {
  switch (props.variation) {
    default:
      return <Default {...props} />;
  }
};
